import { Col, Flex, Form, Row, Select, Typography } from 'antd'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getLookupValues } from 'src/app/store/masterSetup'
import { colorBorderDisabled } from 'src/app/themes/primaryThemeDefault'
import { getCutoffTimeList } from './utils'
import { ErrorMessage } from '@hookform/error-message'

interface ACHExceptionProps {
  control: any
  errors: any
  isCreateAchExceptions: boolean
}

function ACHException(props: ACHExceptionProps) {
  const { control, errors, isCreateAchExceptions } = props
  const { t } = useTranslation()

  const lookupValues = useSelector(getLookupValues)

  const { DefaultAchExceptionCreationType, ACHDecision, ACHDReason, AchAuthorizationRulesNotificationType } =
    lookupValues || {}

  const cutoffTimeList = getCutoffTimeList(15)

  return (
    <Flex vertical style={{ paddingBottom: '24px', flex: 1 }}>
      <Typography.Text style={{ fontSize: '18px', fontWeight: '700', lineHeight: '28px', paddingBottom: '4px' }}>
        {t('ClientSetup:addNewClient.ACHExceptions')}
      </Typography.Text>

      <Flex vertical style={{ border: `1px solid ${colorBorderDisabled}`, padding: '16px', borderRadius: '16px' }}>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label={t('ClientSetup:addNewClient.label.ACHExceptionCreationType')} className='isRequired'>
              <Controller
                name='defaultAchExceptionCreationType'
                control={control}
                render={({ field }) => <Select {...field} options={DefaultAchExceptionCreationType} />}
              />
              <Typography className='error-message'>
                <ErrorMessage errors={errors} name='defaultCheckExceptionCreationType' />
              </Typography>
            </Form.Item>

            {isCreateAchExceptions && (
              <>
                <Form.Item label={t('ClientSetup:addNewClient.label.ACHDecision')} className='isRequired'>
                  <Controller
                    name='defaultAchDecision'
                    control={control}
                    render={({ field }) => <Select {...field} options={ACHDecision} />}
                  />
                </Form.Item>

                <Form.Item
                  label={t('ClientSetup:addNewClient.label.ACHAuthorizationRulesNotificationType')}
                  className='isRequired'
                >
                  <Controller
                    name='achAuthorizationRulesNotificationType'
                    control={control}
                    render={({ field }) => <Select {...field} options={AchAuthorizationRulesNotificationType} />}
                  />
                </Form.Item>
              </>
            )}
          </Col>

          {isCreateAchExceptions && (
            <Col span={12}>
              <Form.Item label={t('ClientSetup:addNewClient.label.ACHExceptionCutoffTime')} className='isRequired'>
                <Controller
                  name='defaultAchExceptionCutoffTime'
                  control={control}
                  render={({ field }) => <Select {...field} options={cutoffTimeList} />}
                  disabled
                />
              </Form.Item>

              <Form.Item label={t('ClientSetup:addNewClient.label.ACHReason')} className='isRequired'>
                <Controller
                  name='defaultAchReason'
                  control={control}
                  render={({ field }) => <Select {...field} options={ACHDReason} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Flex>
    </Flex>
  )
}

export default ACHException
